module.exports = __webpack_public_path__ + "media/images/guide-thumb-4t-c43c6a237f63770af743e45ff5299ad1.png";